"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAreaFromRaw = parseAreaFromRaw;
// Recursively parses raw area data into AreaItems. 
// Returns a flat array of the area and its subareas.
function parseAreaFromRaw(area, parentId = 0) {
    const branchIds = area.Branches?.map(branch => branch.ID) || [];
    const areaItem = {
        id: area.ID,
        name: area.Name,
        parentId,
        branchIds,
        subareaIds: [],
        isTemporary: false,
    };
    const allItems = [areaItem];
    if (area.ChildAreas) {
        for (const child of area.ChildAreas) {
            const childItems = parseAreaFromRaw(child, areaItem.id);
            for (const childItem of childItems) {
                if (childItem.parentId === areaItem.id) {
                    areaItem.subareaIds.push(childItem.id);
                }
            }
            allItems.push(...childItems);
        }
    }
    return allItems;
}
